/**
 * AUTOCOMPLETE COMPONENT ENTRY POINT
 *
 * General purpose autocomplete component. This component is especially
 * useful if you have the suggestions formatted as an array of strings.
 *
 * @version 0.1
 */

import React from 'react';
import { injectIntl } from 'react-intl';
import Autosuggest from 'react-autosuggest';

import utils from './../../utils/utilities';

class Autocomplete extends React.Component {

    constructor(props) {
        super(props);

        if (!utils.isArray(this.props.possibleValues)) {
            throw new TypeError('This component requires a "possibleValues" array parameter.');
        }

        this.state = {
            value:       '',
            suggestions: []
        };

        this.getSuggestionValue = this.getSuggestionValue.bind(this);
        this.filterSuggestions = this.filterSuggestions.bind(this);
        this.renderSuggestion = this.renderSuggestion.bind(this);
        this.onInputChange = this.onInputChange.bind(this);
        this.onSuggestionsFetchRequested = this.onSuggestionsFetchRequested.bind(this);
        this.onSuggestionsClearRequested = this.onSuggestionsClearRequested.bind(this);

        this.possibleValues = this.props.possibleValues;

        if (utils.isObject(this.props.inputProps)) {

            // Save the onChange input prop if specified, in order to be used later
            this.inputOnChangeHandler = typeof(this.props.inputProps.onChange) === 'function' ?
                this.props.inputProps.onChange : null;

        }

    }

    getSuggestionValue(value) {
        return typeof(this.props.getSuggestionValue) === 'function' ? this.props.getSuggestionValue(value) : value;
    }

    filterSuggestions(value) {

        if (typeof this.props.filterSuggestions === 'function') {
            return this.props.filterSuggestions(value, this.possibleValues);
        } else {

            /*
             * Default filtering mechanism
             *
             * A case-insensitive filter to see if the input value is contained inside any of the possible values.
             */

            let inputValue = value.trim().toLowerCase();

            return inputValue.length === 0 ? [] : this.possibleValues.filter(
                (possibleValue) => {
                    return possibleValue.toLowerCase().indexOf(inputValue) > -1;
                }
            );

        }

    };

    renderSuggestion(value) {

        if (typeof(this.props.renderSuggestion) === 'function') {
            return this.props.renderSuggestion(value);
        } else {
            return (
                <div className="autosuggest-option">
                    {value}
                </div>
            );
        }

    }

    onInputChange(event, {newValue, method}) {

        if (this.inputOnChangeHandler) {
            this.inputOnChangeHandler(this, event, {newValue, method});
        } else {
            this.setState({value: newValue});
        }

    }

    onSuggestionsFetchRequested({value}) {
        this.setState({suggestions: this.filterSuggestions(value)});
    }

    onSuggestionsClearRequested() {
        this.setState({suggestions: []});
    }

    render() {

        // Add inputProps if specified else switch to the default value
        let inputProps = {
            placeholder: this.props.intl.formatMessage({id: 'General_CoreFunctionality_UIText_general.enterPhrase'}),
            value:       this.state.value,
            onChange:    this.onInputChange,
            tabIndex:    "1"
        };

        if (utils.isObject(this.props.inputProps)) {

            // Delete any unallowed input properties
            delete this.props.inputProps.onChange;
            delete this.props.inputProps.value;

            inputProps = Object.assign({}, inputProps, this.props.inputProps);

        }

        return (
            <Autosuggest suggestions={this.state.suggestions}
                         onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}
                         onSuggestionsClearRequested={this.onSuggestionsClearRequested}
                         getSuggestionValue={this.getSuggestionValue}
                         renderSuggestion={this.renderSuggestion}
                         inputProps={inputProps} />
        );
    }

}

export default injectIntl(Autocomplete);


// WEBPACK FOOTER //
// ./src/scripts/reusable/Autocomplete/Autocomplete.index.jsx